import React from 'react'
import doctor_na from '../../assets/images/undraw_scientist_0ft9.svg'
import MedicinesFormUpdate from './components/MedicinesFormUpdate'

function MedicinesUpdate() {
  return (
    <section className="hero is-fullheight-with-navbar">
      <div className="hero-body">
        <div className="container">
          <div className="columns is-vcentered">
            <div className="column is-5">
              <figure className="image">
                <img src={doctor_na} alt="Pipeline SVG" />
              </figure>
            </div>
            <div className="column is-7">
              <MedicinesFormUpdate />
            </div>
          </div>
        </div>
      </div>


    </section>
  )
}

export default MedicinesUpdate